import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENV_CONFIG, EnvironmentConfig } from '@libs/vc-core-lib';
import { Observable } from 'rxjs';
import { ITaskModel } from '../model/task.model';

@Injectable({ providedIn: 'root' })
export class TaskBundleService {
    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _environment: EnvironmentConfig = inject(ENV_CONFIG);
    private readonly _taskBundlePath = 'task-bundle';

    public getTasksByTaskBundle(taskBundleId: number): Observable<ITaskModel[]> {
        return this._httpClient.get<ITaskModel[]>(
            `${this._environment.APP.VC_ASSESSMENT_BASE_URL}/${this._taskBundlePath}/${taskBundleId}/tasks`
        );
    }
}
